import { sendHttpRequest } from "lib/fetcher";
export function getCustomers(name?) {
  return sendHttpRequest({
    method: "get",
    url: "/user/customers?page.limit=100&name=" + (name || ""),
  });
}
